import { toast } from "vue-sonner";

export default function usePresaleForm() {
	const { $pb } = useNuxtApp();
	const { pocketbaseAddress } = useRuntimeConfig().public;

	const name = ref("");
	const email = ref("");
	const regularCards = ref(0);
	const discountCards = ref(0);
	const performance = ref<CircusPerformance | null>(null);
	const performances = ref<CircusPerformance[]>([]);
	const isSubmitting = ref(false);
	const submitted = ref(false);

	async function handleSubmit() {
		name.value = name.value.trim().replace(/\s+/g, " ");

		if (regularCards.value + discountCards.value > 15) {
			toast.error(
				"Bitte nutzen Sie die Gruppenanmeldung bei mehr als 15 Karten.",
			);
			return;
		}

		if (
			regularCards.value + discountCards.value >
			(performance.value?.remainingTickets || 0)
		) {
			toast.error(
				"Die von Ihnen gewählte Anzahl an Karten ist für diese Vorstellung nicht mehr verfügbar.",
			);
			return;
		}

		try {
			isSubmitting.value = true;
			await $fetch(`${pocketbaseAddress}/api/presale/create`, {
				method: "POST",
				body: JSON.stringify({
					name: name.value,
					email: email.value,
					regularCards: regularCards.value,
					discountCards: discountCards.value,
					performanceId: performance.value?.id,
				}),

				onResponse: ({ response }) => {
					if (response.ok) {
						toast.success(
							"Bitte bestätigen Sie Ihre Email-Adresse über den Link, den wir Ihnen zugesendet haben.",
						);

						umamiTrack("presale_requested", {
							regularCards: regularCards.value,
							discountCards: discountCards.value,
							performanceId: performance.value?.id,
						});

						submitted.value = true;
					}
				},

				onResponseError: ({ response }) => {
					toast.error(JSON.stringify(response));
				},
			});
		} catch (error) {
			console.error(error);
		} finally {
			isSubmitting.value = false;
		}
	}

	const fetchPerformances = async () => {
		const performancesList = await $pb.collection("performances").getFullList();

		return await Promise.all(
			(performancesList as unknown as CircusPerformance[]).map(
				async (performance) => {
					const remainingTicketsResponse = await $pb.send(
						"/get-remaining-tickets",
						{
							query: {
								performanceId: performance.id,
							},
						},
					);

					performance.remainingTickets =
						remainingTicketsResponse.remaining.total;
					return performance;
				},
			),
		);
	};

	const price = computed(() => {
		return (
			discountCards.value * (performance.value?.discountPrice || 0) +
			regularCards.value * (performance.value?.regularPrice || 0)
		);
	});

	onMounted(async () => {
		performances.value = (await fetchPerformances()).filter(
			(performance) => new Date(performance.date) > new Date(),
		);
	});

	return {
		handleSubmit,
		price,
		name,
		email,
		regularCards,
		discountCards,
		performance,
		submitted,
		isSubmitting,
		performances,
	};
}
